import begnerLogo from "@/assets/begner-logo-256.webp";
import { cn } from "@/lib/utils";

type BrandLogoProps = {
  className?: string;
  imageClassName?: string;
};

export function BrandLogo({ className, imageClassName }: BrandLogoProps) {
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <span
        aria-hidden="true"
        className={cn(
          "relative block size-10 shrink-0 overflow-hidden rounded-lg bg-white shadow-brand",
          imageClassName,
        )}
      >
        <img
          src={begnerLogo}
          alt=""
          width={256}
          height={256}
          decoding="async"
          className="absolute left-1/2 top-1/2 size-[240%] max-w-none -translate-x-1/2 -translate-y-1/2"
        />
      </span>
      <span className="font-display text-xl font-bold tracking-tight text-foreground">
        begner<span className="text-primary">.</span>
      </span>
    </span>
  );
}
